import classNames from 'classnames';
import css from './BannerTopSection.module.scss';

export default function BannerTopSection({children}) {
  return (
    <section className={classNames(css.section, css.bannerOurValues)}>
      {children}
    </section>
  );
}